const zhHK = {
  Language: {
    vi: "越南語",
    en: "英語",
    zh: "中文",
    "zh-HK": "繁體中文（香港）",
    ko: "韓語",
    ja: "日語",
  },
  NAVS: {
    home: "首頁",
    ourHotels: "我們的酒店",
    contactUs: "聯絡我們",
    aboutUs: "關於我們",
    sustainability: "可持續發展",
    careers: "職業發展",
    discoverOurHotels: "探索我們的酒店",
    amanakiSaigonBoutique: "Amanaki 西貢精品酒店",
    amanakiThaoDien: "Amanaki 草甸酒店",
    amanakiHotel: "Amanaki 酒店",
    theHotel: "酒店",
    brandStory: "品牌故事",
    artAmanaki: "藝術與 Amanaki",
    rooms: "客房",
    wellness: "健康養生",
    dining: "餐飲",
    events: "活動",
    offers: "優惠",
    discoverSaigon: "探索西貢",
  },
  Form: {
    required: "必填項",
    emailInvalid: "電郵格式無效。",
    mustBeAccept: "必須接受",
    placeholderFirstName: "名",
    placeholderLastName: "姓",
    placeholderEmail: "電郵地址",
    placeholderPhone: "電話號碼",
    placeholderEnquiry: "選擇查詢類型",
    placeholderWhichHotel: "您想聯絡哪家酒店？",
    placeholderMessage: "您的留言",
    placeholderDepartureDate: "離店日期",
    placeholderArrivalDate: "入住日期",
    placeholderRoomType: "選擇房型",
    placeholderAll: "全部",
    labelPhone: "電話",
  },
  Options: {
    Enquiry: {
      hotelReservation: "酒店預訂",
      wellnessReservation: "健康養生預訂",
      meetingsEvents: "會議與活動",
      pressMedia: "媒體與新聞",
      generalEnquiryFeedback: "一般查詢與反饋",
    },
  },
  Notification: {
    submitSuccess: "您的資料已提交。",
  },
  Footer: {
    name: "Amanaki 酒店",
    address: "草甸區，守德市，胡志明市",
    address10: "10 Nguyen Dang Giai, 草甸區, 胡志明市, 越南",
    address65: "65 Ho Tung Mau, 本義區, 第一區, 胡志明市",
    email: "info@amanaki.vn",
    email10: "info@amanaki.vn",
    email65: "sales@amanakihotels.com",
    phone: "(+84) 82 362 4488",
    phone10: "(+84) 82 362 4488",
    phone65: "(+84) 28 363 4488",
    tel: "電話",
    ourHotels: "我們的酒店",
    thaoDien: "Amanaki 草甸酒店",
    boutiqueSaigon: "Amanaki 西貢精品酒店",
    amanakiHotels: "Amanaki 酒店",
    getToKnowUs: "了解我們",
    whoWeAre: "關於我們",
    sustainabilityImpact: "可持續發展影響",
    ourStories: "我們的故事",
    explore: "探索",
    careers: "職業發展",
    ourOffice: "我們的辦公室",
    getInTouch: "保持聯絡",
    contactUs: "聯絡我們",
    copyright: "© 2023 Amanaki 酒店。保留所有權利。",
    privacyPolicy: "私隱政策",
    adCookiePolicy: "廣告及 Cookie 政策",
    legalNotices: "法律聲明",
  },
  Header: {
    selectAHotel: "選擇酒店",
    aboutAmanaki: "關於 Amanaki",
    ourStories: "網誌",
    contactUs: "聯絡我們",
    ourBlog: "網誌",
    aboutUs: "關於我們",
    sustainability: "可持續發展",
    careers: "職業發展",
  },
  Button: {
    bookNow: "立即預訂",
    discoverMore: "了解更多",
    moreDetail: "更多詳情",
    moreDetails: "更多詳情",
    allOffer: "查看所有優惠",
    viewThisRoom: "查看此客房",
    applyNow: "立即申請",
    viewMap: "查看地圖",
    contactUs: "聯絡我們",
    moreAboutUs: "了解更多",
    enterOurSpaces: "進入我們的空間",
    bookThisRoom: "預訂此客房",
    exploreArtsAndAmanaki: "探索藝術與 Amanaki",
    viewAllStories: "查看所有故事",
    viewAll: "查看全部",
    reserve: "預訂",
    readMore: "閱讀更多",
    exploreMore: "探索更多",
    viewCareers: "查看職業",
    makeAnEnquire: "進行查詢",
    getToKnowOurExecutiveChef: "了解我們的主廚",
    visitOurRestaurant: "參觀我們的餐廳",
    seeOurFacilities: "查看我們的設施",
    submit: "提交",
    checkTheMap: "查看地圖",
    goToMap: "前往地圖",
    requestForProposal: "請求提案",
    bookDirectWithUs: "直接與我們預訂",
    back: "返回",
    backToTop: "返回頂部",
  },
  FAQs: {
    FAQs: "常見問題",
    slogan: "我們在這裡滿足您的所有需求！",
  },
  Stories: {
    title: "啟發人心的故事",
    topic: {
      wellness: "健康養生",
      liveLikeLocal: "像當地人一樣生活",
      whatOn: "最新動態",
    },
    lastestStories: "最新故事",
    interested: "感興趣",
    exploreAllStories: "探索所有故事",
    tags: "標籤",
    share: "分享故事",
  },
  About: {
    aboutAmanaki: "關於 Amanaki",
    aboutUs: "關於我們",
    sustainableDevelopment: "可持續發展",
    careers: "職業發展",
    sustainable: {
      blogs: {
        heading: "您可能也喜歡",
      },
    },
  },
  Wellness: {
    wellness: "健康養生",
    facilitiesService: "設施與服務",
    gallery: "畫廊",
    hours: "營業時間",
    reservations: "預訂",
    location: "位置",
    wellbeingCentre: {
      wellbeingCentre: "健康中心",
    },
    facilities: {
      facilities: "設施",
    },
  },
  Dinning: {
    dinning: "餐飲",
    restaurantInfo: {
      title: "餐廳資訊",
      cuisine: {
        label: "菜系",
        fusionInspired: "越南融合風味",
        viewMenu: "查看菜單",
      },
      reservations: {
        label: "預訂",
        phone: "082 841 1010",
        email: "info@amanaki.vn",
        address: "8 Nguyen Dang Giai, 草甸, 第二區",
      },
      openingHours: {
        label: "營業時間",
        allDay: "全日",
        dinning: "06:00 - 22:00",
        lastOrder: "（最後點餐時間 21:45）",
      },
      executiveChef: {
        label: "主廚",
        name: "Dong Hoang Nam",
      },
      moreInfo: {
        label: "更多資訊",
        amanakiFacebook: "Amanaki Facebook",
      },
    },
  },
  MeetingAndEvents: {
    meetingAndEvents: "會議與活動",
    meetingAndCelebrations: "活動與慶典",
    labelBanner: "激發靈感的創意空間",
    overview: {
      title: "Amanaki 草甸酒店的活動與慶典",
      desc: "無論是字面意義還是象徵意義，11:11 Espace 都位於 Amanaki 草甸酒店的中心——一個創造和交換故事的臨界共存空間。這個 250 平方米的展覽和活動空間是當代越南和國際藝術家展示其創作才華的地方，由 11:11 Espace 策劃和呈現。如果您希望舉辦時尚的藝術和社交活動，請與我們聯絡！",
      phone: "(+84) 82 362 4488",
      email: "info@amanaki.vn",
    },
    requestForProposal: {
      form: {
        fullName: "全名",
        emailAddress: "電郵地址",
        phoneNumber: "電話號碼",
        numberOfAttendees: "預計參加人數",
        desiredSetup: "期望設置",
        desiredSetupOptions: JSON.stringify([
          { label: "宴會", value: "Banquet" },
          { label: "雞尾酒會", value: "CocktailReception" },
          { label: "劇院式", value: "Theatre" },
          { label: "U 型", value: "Ushape" },
          { label: "其他", value: "Other" },
        ]),
        eventDate: "活動日期",
        note: "活動概述、評論、問題及/或特殊要求",
        condition: {
          readAndAccept: "我已閱讀並接受",
          privacyPolicy: "私隱政策",
          keepUpToDateInfo: "我希望接收最新新聞和資訊",
        },
      },
    },
  },
  BrandStory: {
    banner: {
      title: "品牌故事",
    },
  },
  Arts: {
    banner: {
      title: "藝術與 Amanaki",
    },
    exhibitions: {
      tabs: JSON.stringify([
        { label: "即將舉辦的展覽", value: "upcomingExhibition" },
        { label: "當前展覽", value: "currentExhibition" },
        { label: "往期展覽", value: "previousExhibition" },
      ]),
      status: {
        ongoing: "進行中",
        exhibition: "展覽",
      },
    },
  },
  LegalNotice: {
    banner: {
      title: "法律聲明",
    },
    menuOptions: JSON.stringify([
      { label: "私隱政策", value: "PrivacyPolicy" },
      { label: "Cookie", value: "Cookies" },
      { label: "最優價格保證", value: "BestRateGuaranteed" },
    ]),
    cookies: {
      heading: "Cookie",
      data: JSON.stringify([
        {
          title: `1. 什麼是 Cookie？`,
          content: `Cookie 是當您訪問我們的網站時存儲在您的電腦或移動設備 <i>（如智能手機或平板電腦）</i> 上的小文本文件或資訊片段。Cookie 通常包含 Cookie 來源的網站名稱、Cookie 的「生命週期」 <i>（即 Cookie 在您的設備上保留多長時間）</i>，以及一個值，通常是隨機生成的唯一數字。`,
        },
        {
          title: `2. 我們使用 Cookie 的目的是什麼？`,
          content: `我們使用 Cookie 使我們的網站更易於使用，並更好地根據您的興趣和需求定制網站和產品。Cookie 可以做到這一點，因為網站可以讀取和寫入這些文件，使它們能夠識別您並記住重要資訊，從而使您使用網站更加方便 <i>（例如，通過記住偏好設置）</i>。Cookie 也可用於幫助加快您在我們網站上的未來活動和體驗。我們還使用 Cookie 來編譯匿名、匯總的統計數據，使我們能夠了解用戶如何使用我們的網站，並幫助我們改進網站的結構和內容。我們無法從這些資訊中識別您的個人身份。`,
        },
        {
          title: `3. 我們使用哪些類型的 Cookie？`,
          content: `網站上可能使用兩種類型的 Cookie，稱為「會話 Cookie」和「持久 Cookie」。會話 Cookie 是臨時 Cookie，在您離開網站之前一直保留在您的設備上。持久 Cookie 在您的設備上保留更長時間或直到您手動刪除它 <i>（Cookie 在您的設備上保留多長時間取決於特定 Cookie 的持續時間或「生命週期」）</i>。
第三方 Cookie
我們還使用許多供應商，當您訪問我們的網站時，它們可能會代表我們在您的設備上設置 Cookie，以允許它們提供它們正在提供的服務。如果您想了解有關這些 Cookie 的更多資訊，以及如何選擇退出接收此類 Cookie 的資訊，請參閱其私隱政策。`,
        },
        {
          title: `4. 我們使用哪些 Cookie？`,
          content: [
            {
              text: `下面我們列出了可能在 Amanaki.vn 網站上使用的不同類型的 Cookie。請注意，通過 Cookie 收集的資訊構成個人資訊的範圍內，私隱政策中的條款適用並補充本 Cookie 政策。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">基本 Cookie：</span>
基本 Cookie 是網站運行所必需的，使您能夠瀏覽網站並使用其服務和功能。沒有這些絕對必要的 Cookie，網站將無法如我們所願順利運行，我們可能無法提供您請求的網站或某些服務或功能。
<span style="font-weight: 405;">會話</span> – 會話 Cookie 用於維護應用程式的狀態。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">負載均衡</span> – 負載均衡 Cookie 用於在全球範圍內分發資產並減輕伺服器負載。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">用戶 ID</span> – 用戶 ID Cookie 用於確保用戶只能看到自己的資訊。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">安全</span> – 安全 Cookie 用於安全控制和檢查。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">偏好 Cookie</span>
偏好 Cookie 收集有關您的選擇和偏好的資訊，並允許我們記住語言或其他本地設置並相應地自定義網站。
<span style="font-weight: 405;">語言</span> – 語言 Cookie 用於存儲用戶選擇的語言，並顯示正確的選項。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">位置</span> – 用戶的大致地址 <i>（城市、州、國家/地區、郵政編碼）</i> 由 IP 地址確定，以便自動選擇適當的國家/地區並顯示該區域內的零售商和演示日。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">移動設備</span> – 如果用戶在移動設備上查看網站，則設置 Cookie 以指示已選擇主網站 <i>（即設備已啟用 Flash）</i>，或非 Flash 移動網站。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">參考網站</span> – 記錄參考網站以更好地了解用戶的偏好。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">最後訪問和活動</span> – 記錄最後訪問和活動的日期以及其他資訊，以便能夠向用戶提供「自您上次訪問以來網站上的變化」的更新，並更好地了解用戶的偏好。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">最近觀看的視頻</span> – 記錄最近觀看的視頻的日期和標題，以便更好地了解用戶的偏好。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">Flash Cookie</span> – Flash Cookie 用於啟用音頻和視頻內容的播放。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">頁面歷史</span> – 頁面歷史 Cookie 用於跟蹤用戶訪問的頁面序列。如果用戶在訪問網站時收到錯誤消息，Cookie 資訊將保存到日誌文件中以進行錯誤報告和解決。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">社交插件跟蹤 Cookie</span>
此類 Cookie 用於跟蹤社交媒體網絡的成員 [和非成員]，用於市場研究分析和產品開發。
<span style="font-weight: 405;">Facebook</span> – Cookie 用於跟蹤 Facebook 成員 [和非成員]，用於市場研究分析和產品開發。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">分析 Cookie</span>
分析 Cookie 收集有關您使用網站的資訊，並使我們能夠改進其工作方式。例如，分析 Cookie 向我們顯示網站上訪問最頻繁的頁面，幫助我們記錄您在使用網站時遇到的任何困難，並向我們顯示我們的廣告是否有效。這使我們能夠查看網站上的整體使用模式，而不是單個人的使用情況。
<span style="font-weight: 405;">Google Analytics</span> – Google Analytics Cookie 收集匯總統計數據以改進網站展示和導航。Google 用人口統計和興趣資訊補充匯總數據，以便我們能夠更好地了解我們的訪問者。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">Adobe Omniture</span> – Adobe Omniture 分析 Cookie 收集匯總統計數據以改進網站展示和導航。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。`,
            },
            {
              bullet: true,
              text: `<span style="font-weight: 405;">營銷 Cookie</span>
廣告 Cookie 用於營銷目的。
<span style="font-weight: 405;">廣告</span> – 提供行為/定向廣告。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">市場分析</span> – 進行市場分析。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">活動/促銷</span> – 衡量活動的有效性。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。
<span style="font-weight: 405;">欺詐檢測</span> – 檢測點擊欺詐。可以通過瀏覽器設置接受/拒絕來管理這些 Cookie。`,
            },
          ],
        },
        {
          title: `5. 如何管理 Cookie？`,
          content: `儘管大多數互聯網瀏覽器最初設置為自動接受 Cookie，但大多數互聯網瀏覽器允許您更改設置以阻止 Cookie 或在 Cookie 發送到您的設備時提醒您。
除了上面提供的選項外，您還可以隨時通過激活或訪問瀏覽器上的設置來拒絕、接受或刪除網站上的 Cookie。有關啟用、禁用或刪除 Cookie 所需遵循的程序的信息，可以通過幫助屏幕在您的互聯網瀏覽器提供商的網站上找到。
請注意，如果禁用或刪除 Cookie，網站的所有功能可能無法按預期運行，例如，您可能無法訪問我們網站的某些區域，或者在訪問網站時可能無法接收個性化資訊。
如果您使用不同的設備查看和訪問網站 <i>（例如您的電腦、智能手機、平板電腦等）</i>，您需要確保每個設備上的每個瀏覽器都經過調整以適合您的 Cookie 偏好。
如果您想清理您訪問過的網站留下的所有 Cookie，您可以找到清理跟蹤 Cookie 的第三方網站。
這些第三方網站不在我們的控制之下，我們不對這些網站做出任何陳述或保證。如果您決定訪問這些第三方網站，我們建議您在使用該網站之前查看任何第三方網站的相應條款和條件以及私隱政策。`,
        },
        {
          title: `6. 像素標籤`,
          content: `您訪問的網站上的某些頁面也可能通過使用像素標籤 <i>（也稱為清晰 gif）</i> 收集資訊，這些資訊可能與直接支持我們的促銷活動和網站開發的第三方共享。例如，有關訪問我們網站的訪問者的網站使用資訊可能與我們的第三方廣告代理商共享，以便更好地在我們的網站上定位互聯網橫幅廣告。但是，通過使用這些像素標籤收集的資訊不是個人可識別的，儘管它可能與您的個人資訊相關聯。`,
        },
        {
          title: `7. 聯絡我們`,
          content: `如果您對此 Cookie 政策有任何疑問，請通過 <a href="mailto:info@amanaki.vn" style="color: #af915e">info@amanaki.vn</a> 與我們聯絡。請注意，電郵通信並不總是安全的，因此請不要在您發送給我們的電郵中包含信用卡資訊或敏感資訊。`,
        },
      ]),
    },
    bestRateGuaranteed: {
      heading: "最優價格保證",
      title: "直接通過 AMANAKI 預訂，保證最優價格。",
      data: JSON.stringify([
        {
          content: `您在 Amanaki 的住宿，從開始到結束，都是我們的優先事項。當您直接在我們的官方網站上預訂住宿時，這段旅程就開始了，您將得到保證：`,
        },
        {
          content: [
            `您住宿的最低價格`,
            `最靈活的取消條款`,
            `訪問我們專門的預訂專家以幫助您預訂`,
            `在整個住宿期間享受最佳服務`,
            `如果您在預訂後 24 小時內找到更低的合格價格，我們將匹配較低的價格。`,
          ],
        },
      ]),
    },
  },
  HomeHotel10: {
    experiencing: {
      title: "體驗 Amanaki",
    },
  },
  Offers: {
    offer: "優惠",
  },
  Offer: {
    valid: "有效期至 {{date}}",
    otherOffer: "其他優惠",
  },
  ContactUs: {
    description: `如果您對我們的酒店、酒店預訂或在我們的餐廳或健康中心預訂有任何疑問，請聯絡我們。`,
    getInTouch: "保持聯絡",
    descInTouch: `我們很高興收到您的來信，請使用下面的詳細資訊與我們聯絡。`,
    iConfirm: "我確認我已閱讀並理解 Amanaki 酒店",
    privacy: "私隱政策",
    acceptReceiveInfomation:
      "是的！我希望接收來自 Amanaki 酒店的特殊優惠和促銷活動，包括酒店、餐飲和水療促銷",
    addressAmanakiThaoDien: `10 Nguyen Đang Giai, 草甸區, 守德市, 胡志明市`,
    addressAmanakiSaigonBoutique: `65 Ho Tung Mau, 本義區, 第一區, 胡志明市`,
  },
  Discover: {
    title: "探索西貢",
    description:
      "\"每座建築，每個店面，似乎都通向一個不同的世界，將人類生活的所有多樣性壓縮成各種可能性的混合體，通過連接而變得更加豐富。\"<0/>Rebecca Solnit",
    BlockLocation: {
      distanceAmanaki: "從 Amanaki 出發的方向：",
      checkMap: "查看地圖",
    },
    BlockOurLocation: {
      ourLocation: "我們的位置",
      getting: "前往 Amanaki<0/>草甸酒店",
      address: "10 Nguyen Dang Giai 街, 草甸區, 守德市, 胡志明市",
      phone: "(+84) 82 3624488",
      airport: "新山一國際機場",
      airportDescription: `從新山一國際機場<0/>
距離酒店：13 公里<0/>
機場班車服務：500,000 越南盾/次`,
      tel: "電話",
    },
  },
  Breadcrumb: {
    stories: "我們的故事",
    category: "類別",
    amanakiThaoDien: "Amanaki 草甸酒店",
    "amanaki-thao-dien": "Amanaki 草甸酒店",
    "amanaki-boutique-saigon": "Amanaki 西貢精品酒店",
    theHotel: "酒店",
  },
  Rooms: {
    Signature: "簽名",
    Executive: "行政",
    Premium: "高級",
    FamilySuite: "家庭套房",
    otherRooms: "其他客房",
    theDetails: "詳情",
    utilities: "設施",
    amenities: "便利設施",
    checkIn: "入住",
    checkOut: "退房",
    visitOurRooms: "參觀我們的客房",
    Banner: {
      title: "參觀我們的客房",
      description: `放慢腳步，睜大眼睛。<0/>在裡面，一段歷史正在溫柔地看著您。`,
    },
  },
  DateFormat: {
    Default: "DD/MM/YYYY",
    FullDisplay: "HH:mm:ss - DD/MM/YYYY",
    Unit: {
      second: "秒",
      minute: "分鐘",
      hour: "小時",
    },
    Time: "LT",
  },
  SearchControl: {
    room: "客房",
    adults: "成人",
    children: "兒童",
    bestPrice: "保證最優價格",
    checkAvailability: "檢查可用性",
  },
  Time: {
    minutes: "{{n}} 分鐘",
  },
  Filter: {
    clearFilter: "清除篩選",
    categoryPlaceholder: "類別",
    placeholderCategory: "類別",
    sortPlaceholder: "排序",
    lastestLabel: "最新文章",
    oldestLabel: "最舊文章",
  },
  Error: {
    pageNotFound: "頁面未找到",
    pageNotFoundDescription: "您要查找的頁面不存在或已被移動。",
    serverError: "伺服器錯誤",
    serverErrorDescription: "伺服器出現了問題。請稍後再試。",
    goHome: "返回首頁",
  },
  CookieConsent: {
    message: "我們使用 Cookie 來改善您的體驗並分析網站流量。點擊接受即表示您同意我們使用 Cookie。請參閱我們的",
    privacyPolicy: "隱私政策",
    acceptAll: "全部接受",
    rejectAll: "全部拒絕",
    managePreferences: "管理偏好設定",
    preferencesTitle: "Cookie 偏好設定",
    preferencesDescription: "選擇您允許的 Cookie。您可隨時更改這些設定。了解更多請參閱我們的",
    savePreferences: "儲存偏好設定",
    cancel: "取消",
    categoryNecessary: "必要 Cookie",
    categoryFunctional: "功能 Cookie",
    categoryAnalytics: "分析 Cookie",
    categoryMarketing: "行銷 Cookie",
    alwaysRequired: "始終開啟",
    categoryNecessaryDesc: "網站運行所必需，無法停用。",
    categoryFunctionalDesc: "記住您的偏好設定，如語言和地區。",
    categoryAnalyticsDesc: "幫助我們了解訪客如何使用網站以進行改進。",
    categoryMarketingDesc: "用於個人化廣告和行銷活動。",
    toggleLabel: "切換 Cookie 類別",
    cookiePreferences: "Cookie 偏好設定",
  },
};
export default zhHK;


